import { render, staticRenderFns } from "./DashboardGestaoProblemas.vue?vue&type=template&id=d6f951a6&scoped=true"
import script from "./DashboardGestaoProblemas.vue?vue&type=script&lang=js"
export * from "./DashboardGestaoProblemas.vue?vue&type=script&lang=js"
import style0 from "./DashboardGestaoProblemas.vue?vue&type=style&index=0&id=d6f951a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f951a6",
  null
  
)

export default component.exports